import './NavImageCTAs.scss';

import { CTA, IFlyoutImage, StoreIdentifierName } from 'types';
import {
  HomefieldIconChevronDown,
  HomefieldIconChevronUp,
  HomefieldIconPlChevronDown,
  HomefieldIconPlChevronUp,
} from '@dsg-tech/homefield-react-icons';
import { checkStores, setDataEmTag } from 'utility/utility';

import React from 'react';
import { handleADA } from '@dsg-tech/homefield-utils';

type Props = {
  navImageAndCtas: INavImageAndCtas;
  showImageAndCTAData: boolean;
  imageDataAccordionClickHandler: () => void;
  dataEmCatTitle: string;
  storeIdentifierName: StoreIdentifierName;
  featureNavOnTopEnabled: boolean;
};

interface INavImageAndCtas {
  flyoutImage: IFlyoutImage[];
  cta: CTA[];
}

export default function NavImageAndCTAs({
  navImageAndCtas,
  showImageAndCTAData,
  imageDataAccordionClickHandler,
  dataEmCatTitle,
  storeIdentifierName,
  featureNavOnTopEnabled,
}: Props) {
  const chevronDown =
    storeIdentifierName === 'dsg' ? (
      <HomefieldIconChevronDown height="24px" width="24px" />
    ) : (
      <HomefieldIconPlChevronDown height="10px" width="10px" />
    );
  const chevronUp =
    storeIdentifierName === 'dsg' ? (
      <HomefieldIconChevronUp height="24px" width="24px" />
    ) : (
      <HomefieldIconPlChevronUp height="10px" width="10px" />
    );

  const navImageUpload = (imageUpload: string, link: string, linkTitle: string, title: string) => {
    return (
      <div className="flyOutImage-container">
        <img
          className="image"
          src={`https://images.dickssportinggoods.com/marketing/${imageUpload}`}
          role="img"
          alt=""
          loading="lazy"
        />
        <div className="image-text hmf-p-s">
          <p className="title hmf-header-bold-s hmf-pb-xs">{title}</p>
          <a
            className="cta hmf-subheader-bold-m"
            href={checkStores(link)}
            data-em={setDataEmTag('TopNav', dataEmCatTitle, 'Creative', title)}>
            {linkTitle}
          </a>
        </div>
      </div>
    );
  };

  const NavImage = ({ imageUpload, link, linkTitle, title }: IFlyoutImage) => {
    return (
      <>
        {!featureNavOnTopEnabled && navImageUpload(imageUpload, link, linkTitle, title)}
        <div className="below-image-cta-container hmf-body-m">
          {navImageAndCtas.cta?.map((cta: CTA, index: number) =>
            cta.linkTitle && index ? (
              <div className="hmf-p-m" key={`cta-${cta.linkTitle}`}>
                <a
                  className="below-image-cta hmf-mb-m"
                  href={checkStores(cta.link)}
                  data-em={setDataEmTag('TopNav', dataEmCatTitle, 'FeaturedColumn', cta.linkTitle)}>
                  {cta.linkTitle}
                </a>
              </div>
            ) : null,
          )}
        </div>
        {featureNavOnTopEnabled && navImageUpload(imageUpload, link, linkTitle, title)}
      </>
    );
  };

  return (
    <>
      {navImageAndCtas.flyoutImage.map((imageData: IFlyoutImage) => {
        if (!imageData.imageUpload) return null;
        return (
          <div key={`accordion-${imageData.title}`} className="accordion-container__accordion">
            <button
              type="button"
              tabIndex={0}
              className="accordion-container__accordion--category hmf-body-bold-l hmf-px-s hmf-py-m"
              onClick={() => imageDataAccordionClickHandler()}
              onKeyDown={(e) => handleADA(e, 'button', imageDataAccordionClickHandler)}
              data-em={setDataEmTag('TopNav', dataEmCatTitle, imageData.title)}>
              {showImageAndCTAData && <span className="flag" />}
              {navImageAndCtas.cta[0].linkTitle}
              {!showImageAndCTAData ? chevronDown : chevronUp}
            </button>
            {((featureNavOnTopEnabled && !showImageAndCTAData) ||
              (!featureNavOnTopEnabled && showImageAndCTAData)) && (
              <div className="accordion-container__accordion--sublink-container image-cta-accordion">
                {NavImage(imageData)}
              </div>
            )}
          </div>
        );
      })}
      ;
    </>
  );
}
